import { render, staticRenderFns } from "./schoolAgreement.vue?vue&type=template&id=e37f00b6&scoped=true&"
import script from "./schoolAgreement.vue?vue&type=script&lang=js&"
export * from "./schoolAgreement.vue?vue&type=script&lang=js&"
import style0 from "./schoolAgreement.vue?vue&type=style&index=0&id=e37f00b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37f00b6",
  null
  
)

export default component.exports